<template>
	<div class="relative" :class="formClass">
		<input
			type="text"
			v-model="model"
			:placeholder="placeholder"
			class="input w-full"
			autocomplete="off"
			tabindex="1"
		/>
		<i class="fas fa-solid fa-magnifying-glass fa-fw fa-lg head_icon" />
		<i
			class="fas fa-solid fa-xmark fa-fw fa-lg footer_icon"
			@click="searchClear"
		/>
	</div>
</template>

<script setup>
import { computed, watch, onMounted, ref } from "vue";

/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["searchClear"]);
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	formClass: [String, Array],
	placeholder: String
});
const model = defineModel();
/* ---------------------------------------------------------------------------
	絞り込み検索のクリア
---------------------------------------------------------------------------- */
function searchClear() {
	emit("searchClear");
}
/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.input {
	height: 40px;
	font-size: 1.4rem;
	position: relative;
	font-weight: normal;
	@include trans(0.3);
	padding: 10px 30px 8px 35px;
	border-radius: 5px;
	border: 1px solid $bg-gray2;
	&:focus {
		@include trans(0.3);
		border-color: $bg-blue2;
		background-color: rgba(0, 104, 179, 0.1);
	}
}
.input::placeholder {
	color: #d9d9d9;
}
.head_icon {
	position: absolute;
	top: 21px;
	left: 7px;
	color: $color-gray3;
}
.footer_icon {
	cursor: pointer;
	position: absolute;
	top: 21px;
	right: 7px;
	color: $color-gray3;
	@include trans(0.3);
	&:hover {
		color: $color-gray4;
		@include trans(0.3);
	}
}
</style>
